<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div id="notfound">
                    <div class="notfound">
                        <div class="notfound-404">
                            <h1>:(</h1>
                        </div>
                        <h2>{{ $t('page_404_the_page_you_are_looking_for_cannot_be_found') }}</h2>
                        <p>{{ $t('the_url_of_the_page_you_are_looking_for_may_have_been_changed_or_deleted') }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { isLogin } from "@/js/commons/commons"
export default {
    async mounted() {
        if (isLogin() && this.$store.state.auth.typeOfUser === 'doctor') {
            this.$store.dispatch('auth/getDoctorInfo')
        }
        // change font-size for tag h1 to 140px on Window
        if (navigator.userAgent.indexOf("Win") != -1) {
            $('.notfound-404 h1').css({'font-size': '140px'})
        }
    }
}
</script>
<style lang="scss">
#notfound {
    position: relative;
    height: 89vh;
}

#notfound .notfound {
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

.notfound {
    max-width: 710px;
    width: 100%;
    padding-left: 140px;
    line-height: 1.4;
}

.notfound .notfound-404 {
    position: absolute;
    left: 0;
    top: 0;
    width: 150px;
    height: 150px;
}

.notfound .notfound-404 h1 {
    font-family: "Passion One", cursive;
    color: #ff89c0;
    font-size: 150px;
    letter-spacing: 15.5px;
    margin: 0px;
    font-weight: 900;
    position: absolute;
    top: -30%;
}

.notfound h2 {
    font-family: "Raleway", sans-serif;
    color: #292929;
    font-size: 28px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 2.5px;
    margin-top: 0;
}

.notfound p {
    font-family: "Raleway", sans-serif;
    font-size: 14px;
    font-weight: 400;
    margin-top: 0;
    margin-bottom: 15px;
    color: #333;
}

@media only screen and (max-width: 480px) {
    .notfound {
        text-align: center;
    }
    .notfound .notfound-404 {
        position: relative;
        width: 100%;
        margin-bottom: 15px;
    }
    .notfound {
        padding-left: 15px;
        padding-right: 15px;
    }
}
</style>
